import {BasketItemModel} from '@features/basket/interfaces';

export const getBasketChecked = (items: BasketItemModel[], itemsOut: BasketItemModel[]) => {
    const allChecked = items.every((item) => item.checked);
    const allCheckedItemsOut = itemsOut.every((item) => item.checked);

    return {allChecked, allCheckedItemsOut};
}